<template>
  <PrintPageLandscape>
    <PresentationPage :page-number="pageNumber" :page-count="pageCount">
      <p class="presentation-page__eyebrow">B2C · Privatkunden</p>

      <h2 class="presentation-page__title">Private Anlagen — schlüsselfertige Energielösung</h2>

      <p class="presentation-page__text">
        Vom Eigenheim bis zum Mehrfamilienhaus. Geplant, geliefert und betrieben aus einer Hand.
      </p>

      <div class="presentation-page__group-cards">
        <article v-for="card in cards" :key="card.header" class="presentation-page__group-card">
          <div
            :class="[
              'presentation-page__group-card-header',
              `presentation-page__group-card-header--${card.accent}`,
            ]"
          >
            {{ card.header }}
          </div>

          <div
            class="presentation-page__group-card-body presentation-page__group-card-body--extended"
          >
            <div class="presentation-page__group-card-title-row">
              <h3 class="presentation-page__group-card-title">{{ card.title }}</h3>
              <div class="presentation-page__group-card-title-icon" aria-hidden="true">
                <i :class="['fa', card.icon]"></i>
              </div>
            </div>

            <p class="presentation-page__group-card-text">{{ card.text }}</p>

            <div class="presentation-page__group-card-accent" aria-hidden="true"></div>

            <ul class="presentation-page__list">
              <li v-for="item in card.items" :key="item">{{ item }}</li>
            </ul>
          </div>
        </article>
      </div>

      <p class="presentation-page__caption">
        Über 4.500 Privatanlagen installiert · Deutschlandweit aktiv · Eigene Monteure
      </p>
    </PresentationPage>
  </PrintPageLandscape>
</template>

<script>
import PrintPageLandscape from '@/components/Print/PrintPageLandscape.vue';
import PresentationPage from '@/views/MasterPresentation/PresentationPage';

export default {
  name: 'MasterPresentationPrintPage13',

  components: {
    PrintPageLandscape,
    PresentationPage,
  },

  props: {
    project: { type: Object, default: null },
    pageCount: { type: Number, default: null },
    pageNumber: { type: Number, default: 0 },
  },

  data() {
    return {
      cards: [
        {
          header: 'Standardlösung',
          accent: 'brand-primary',
          icon: 'fa-home',
          title: 'Standardisierte Dachanlagen mit Speicher',
          text:
            'Vorkonfigurierte All-in-One-Pakete für Eigenheime. Module, Wechselrichter, Speicher und Wallbox aus einer Hand — preislich planbar und schnell installiert.',
          items: ['3–10 kWp Anlagengröße', 'Inkl. Speicher 5–15 kWh', 'Ersatzstrom optional'],
        },
        {
          header: 'Qualitätsstandard',
          accent: 'brand-secondary',
          icon: 'fa-shield',
          title: 'Hoher Qualitäts- und Dokumentationsstandard',
          text:
            'Lückenlose Foto- und Messprotokolle, 4-Augen-Abnahme nach DIN/VDE/RAL. Banken- und versicherungstaugliche Dokumentation digital über RETIS.',
          items: ['Tier-1-Komponenten', 'TÜV-zertifizierte UK', 'Digitale Dokumentation'],
        },
        {
          header: 'Turnkey-Prozess',
          accent: 'brand-teal',
          icon: 'fa-cogs',
          title: 'Schlüsselfertige Umsetzung',
          text:
            'Ein Ansprechpartner, ein Festpreis, ein Termin. Wir übernehmen Planung, Genehmigung, Montage, Netzanschluss und Marktstammdaten — Sie schalten ein.',
          items: ['4–8 Wochen ab Auftrag', 'Eigene Montageteams', '20 Jahre O&M inklusive'],
        },
      ],
    };
  },
};
</script>
